// extracted by mini-css-extract-plugin
export default {"pageButton":"PageButton_pageButton__xKCXp","value":"PageButton_value__jDMdQ","pageButton_active":"PageButton_pageButton_active__fYzHd"};